export const WidgetChartType = {
  Bar: 0,
  Area: 1,
  Scatter: 2,
  Line: 3,
};
